import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types';

import {
  PAGE_NOT_FOUND_ROUTE,
  REDIRECT_ROUTE,
  REDIRECT_EDITOR_ROUTE,
} from '/@/router/routes/basic';

import { PageEnum } from '/@/enums/pageEnum';
import { t } from '/@/hooks/web/useI18n';
import { LAYOUT } from '/@/router/constant';

// import.meta.globEager() 直接引入所有的模块 Vite 独有的功能
const modules = import.meta.globEager('./modules/**/*.ts');
const routeModuleList: AppRouteModule[] = [];

// 加入到路由集合中
Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];

// 根路由
export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  component: LAYOUT,
  meta: {
    title: 'Root',
  },
  children: [
    {
      path: '/',
      name: 'Index',
      meta: {
        title: '首页',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/index/index.vue'),
    },
  ],
};

export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  redirect: '/',
  meta: {
    title: t('routes.basic.login'),
  },
};

// 冷启动页面
const CreateOrgRoute: AppRouteRecordRaw = {
  path: '/create-org',
  name: 'CreateOrg',
  component: () => import('/@/views/create-org/index.vue'),
  meta: {
    title: '创建组织-灵图',
  },
};

// 授权页面
const AuthorizationRoute: AppRouteRecordRaw = {
  path: '/authorization',
  name: 'Authorization',
  component: () => import('/@/views/authorization/index.vue'),
  meta: {
    title: '登录-灵图',
  },
};

// 授权页面
const BrowserExtensionAuthorizationRoute: AppRouteRecordRaw = {
  path: '/browser-extension-authorization',
  name: 'BrowserExtensionAuthorization',
  component: () => import('/@/views/browser-extension-authorization/index.vue'),
  meta: {
    title: '登录-灵图',
  },
};

// batch授权页面
const BatchAuthorizationRoute: AppRouteRecordRaw = {
  path: '/batch/authorization/:type',
  name: 'BatchAuthorization',
  component: () => import('/@/views/batch/authorization/index.vue'),
  meta: {
    title: '授权-灵图',
  },
};

// batch 授权跳转页面
const BatchAuthRedirectRoute: AppRouteRecordRaw = {
  path: '/batch/auth-redirect/:type',
  name: 'BatchAuthRedirect',
  component: () => import('/@/views/batch/authorization/redirect.vue'),
  meta: {
    title: '授权-灵图',
  },
};

const BrowserExtensionGuideRoute: AppRouteRecordRaw = {
  path: '/browser-extension-guide',
  name: 'BrowserExtensionGuide',
  component: () => import('/@/views/browser-extension-guide/index.vue'),
  meta: {
    title: '插件使用引导-灵图',
  },
};

// 邀请页面
const InvitationRoute: AppRouteRecordRaw = {
  path: '/invitation/:code',
  name: 'Invitation',
  component: () => import('/@/views/invitation/index.vue'),
  meta: {
    title: '邀请-灵图',
  },
};

// 页面失效
const InvalidOrgRoute: AppRouteRecordRaw = {
  path: '/invalid-org',
  name: 'InvalidOrg',
  component: () => import('/@/views/invalid-org/index.vue'),
  meta: {
    title: '页面失效-灵图',
  },
};

// 支付详情
const PaySuccessRoute: AppRouteRecordRaw = {
  path: '/pay-success',
  name: 'PaySuccess',
  meta: {
    title: '支付详情',
    ignoreKeepAlive: false,
    hideMenu: true,
  },
  component: () => import('/@/views/commerce/pay-success/index.vue'),
};

const WxLoginRoute: AppRouteRecordRaw = {
  path: '/wx-login',
  name: 'WxLogin',
  meta: {
    title: '微信登录',
    ignoreKeepAlive: false,
    hideMenu: true,
  },
  component: () => import('/@/views/wx-login/index.vue'),
};

// 演示用的智能编辑页面
const SmartRoute: AppRouteRecordRaw = {
  path: '/smart-editor/:ability',
  name: 'SmartEditor',
  component: () => import('/@/views/smart-editor/index.vue'),
  meta: {
    title: '智能编辑',
  },
};

// Basic routing without permission
// 未经许可的基本路由
export const basicRoutes = [
  AuthorizationRoute,
  BrowserExtensionAuthorizationRoute,
  BatchAuthorizationRoute,
  BatchAuthRedirectRoute,
  BrowserExtensionGuideRoute,
  CreateOrgRoute,
  InvitationRoute,
  LoginRoute,
  RootRoute,
  REDIRECT_EDITOR_ROUTE,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
  InvalidOrgRoute,
  PaySuccessRoute,
  WxLoginRoute,
  SmartRoute,
  ...asyncRoutes,
];
